const IP_HOST = process.env.REACT_APP_IP_SERVER ? `${process.env.REACT_APP_IP_SERVER}/api` : 'http://localhost:3977/api';
const NODE_ENVE = process.env.REACT_APP_NODE_ENVE ;


let IP_SERVER;
  console.log("aqui esta", NODE_ENVE);
  console.log("-------------------------------------------");

if (!process.env.REACT_APP_IP_SERVER || IP_HOST === 'http://localhost:3977/api') {
    console.log("Se trabaja en localhost");
    IP_SERVER = 'http://localhost:3977/api';

} else {
    console.log("Se trabaja en el servidor");
    IP_SERVER = `${process.env.REACT_APP_IP_SERVER}/api`;
}

console.log("IP del servidor:", IP_SERVER);

export const basePath = IP_SERVER;
console.log("La IP del servidor es", basePath, "del sistema de consulta");

export const apiVersion = "v1";
